module.exports = __webpack_public_path__ + "img/Share.18ec6f3.svg";